import './AcceptInvite.css';

import { MouseEvent, useCallback } from 'react';
import { Bendie, BendieAnimation, Motion } from 'components/bendies/Bendie';
import { Button } from 'components/core/button';
import { Text } from 'components/core/text';
import Logo from 'public/assets/logo.svg';
import { useLocation, useNavigate } from 'react-router-dom';

export default function AcceptInviteSuccessPage() {
  const location = useLocation();
  const push = useNavigate();
  const clickHandler = useCallback(
    (e: MouseEvent<HTMLButtonElement>) => {
      e.preventDefault();
      e.stopPropagation();

      const newLocation = location.state?.['redirect'];

      if (newLocation) {
        window.location.href = newLocation;
        return;
      } else {
        push('/home');
      }
    },
    [location.state, push],
  );

  return (
    <div className="AcceptInvitePage grid-12 m-grid-6 bendie-grid">
      <div className="span-6 left-panel">
        <div className="left-panel-inner register-gradient centered-column pt-16-m">
          <div className="bendie-wrapper">
            <BendieAnimation bendie={Bendie.Hal} motion={Motion.Dance} />
          </div>
        </div>
      </div>
      <div className="span-6 right-panel centered-column">
        <div
          style={{
            maxWidth: 400,
            textAlign: 'center',
            alignItems: 'center',
            display: 'flex',
            flexDirection: 'column',
          }}
        >
          <img className="content-logo" src={Logo} />
          <Text variant="heading3" style={{ paddingBottom: 8 }}>
            Success!
          </Text>
          <Text block variant="text4">
            Your password has been set. Please log in to access the member
            portal.
          </Text>
          <div className="submit-wrapper" style={{ paddingTop: 32 }}>
            <Button onClick={clickHandler}>Back to log in</Button>
          </div>
        </div>
      </div>
    </div>
  );
}
